//接口基准路径

//线上地址
// const api_url = 'https://cjsz.xiaocx.org/Admin';

//测试地址
const api_url = 'https://api.xiaocx.org/Admin';

// 七牛云域名
// const upload_url = 'http://up-z2.qiniup.com/';
const upload_url = 'http://up-z2.qiniup.com/';

// 七牛云文件地址
const upload_excel = 'http://cjsz-cdn.xiaocx.org/';


export default {
    api_url,
    upload_url,
    upload_excel
}



// WEBPACK FOOTER //
// ./src/util/common.js